import { type SelfDescribingJson } from '@snowplow/tracker-core';

import { getGlobalSignupApplicationContext } from './globalSignupApplicationContext';
import { signupApplicationEntity } from './trackingEvents';

const getSignupApplicationSnowplowContext = (): SelfDescribingJson | null => {
  const applicationContext = getGlobalSignupApplicationContext();

  if (!applicationContext) return null;

  const entity = signupApplicationEntity(applicationContext);

  if (
    !('snowplow' in entity) ||
    !entity.snowplow ||
    typeof entity.snowplow.schema !== 'string'
  ) {
    return null;
  }

  return {
    data: { ...entity.data } as Record<string, unknown>,
    schema: entity.snowplow.schema,
  };
};

export { getSignupApplicationSnowplowContext };
